<template>
  <div class="base-text-4" v-html="text"/>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.base-text-4 {
  font-family: 'Klavika Bold Italic';
  font-size: 0.625rem;
  --letter-spacing: 0.05em;
  letter-spacing: var(--letter-spacing);
  margin: 0.5rem 0;
}
</style>
